// src/context/LanguageContext.jsx
import React, { createContext, useState, useContext, useEffect } from 'react';
import translations from '../i18n/translations';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState('en');

    // 初始化：检测浏览器语言或读取 localStorage
    useEffect(() => {
        const savedLang = localStorage.getItem('language');
        if (savedLang) {
            setLanguage(savedLang);
        } else {
            // 检测浏览器语言
            const browserLang = navigator.language || navigator.userLanguage;
            if (browserLang.startsWith('zh')) {
                setLanguage('zh');
            } else {
                setLanguage('en');
            }
        }
    }, []);

    // 切换语言
    const toggleLanguage = () => {
        const newLang = language === 'en' ? 'zh' : 'en';
        setLanguage(newLang);
        localStorage.setItem('language', newLang);
    };

    // 获取翻译文本
    const t = (path) => {
        const keys = path.split('.');
        let result = translations;
        for (const key of keys) {
            if (result[key]) {
                result = result[key];
            } else {
                return path; // 返回路径作为 fallback
            }
        }
        return result[language] || result['en'] || path;
    };

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
}
